<template>
    <div class="documents_view">
        <b-container fluid class="bv-example-row">
            <b-row>
                <b-col cols="7">
                    <card>
                        <DocumentOptionList ref="optionList" v-on:selectedItem="onListSelection"
                            v-on:newItem="this.createNewDoc" />
                    </card>
                </b-col>
                <b-col cols="5">
                    <InfoCard v-if="action == ''"></InfoCard>
                    <b-card v-else>
                        <b-alert variant="alert" :show="selectedDocumentCount != 1">{{
                            $t('document_view.select_hint_txt') }}</b-alert>
                        <b-tabs pills card align="center" fill>
                            <b-tab :title="$t('document_view.content')">
                                <b-card-text>
                                    <DocumentEditForm ref="txtFormEditor" :creatingNew="this.creatingNew"
                                        v-bind:editordata="this.formData"></DocumentEditForm>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="$t('document_view.validity')">
                                <b-collapse :visible="editorsVisible">
                                    <DocumentValidityEditor ref="validityEditor" :creatingNew="this.creatingNew"
                                        v-bind:docOptJsonMsg="this.formData" />
                                </b-collapse>
                                <b-collapse :visible="!editorsVisible">
                                    {{ $t('document_view.select_hint_txt') }}
                                </b-collapse>
                                <b-card-text> </b-card-text>
                            </b-tab>
                            <b-tab :title="$t('document_view.targets')">
                                <b-collapse :visible="editorsVisible">
                                    <DocumentTargets ref="targetCtrl" :creatingNew="this.creatingNew"
                                        :targetdata="this.targetList">
                                    </DocumentTargets>
                                </b-collapse>
                                <b-collapse :visible="!editorsVisible">
                                    {{ $t('document_view.select_hint_txt') }}
                                </b-collapse>
                            </b-tab>
                        </b-tabs>
                        <FormButtons ref="formButtonit" @reset="this.resetDocumentData"
                            @submit="this.submitDocumentData" @remove="this.removeDocumentOption"
                            :disableReset="formButtons.enabled" :disableSubmit="formButtons.enabled"
                            :disableRemove="formButtons.removeDisabled" :itemid="this.documentOptionId">
                        </FormButtons>
                        <RequestInfo></RequestInfo>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import DocumentOptionList from '@/components/Content/Documents/DocumentOptionList.vue';
import DocumentEditForm from '@/components/Content/Documents/DocumentEditForm.vue';
import DocumentValidityEditor from '@/components/Content/Documents/DocumentValidityEditor.vue';
import DocumentTargets from '@/components/Content/Documents/DocumentTargetControl.vue';
import FormButtons from '@/components/Misc/FormButtons.vue';
import RequestInfo from '@/components/Misc/RequestInfo.vue';

import documents from '@/store/documents/documents'

export default {
    name: 'DocumentView',
    components: {
        DocumentOptionList,
        DocumentEditForm,
        DocumentValidityEditor,
        DocumentTargets,
        FormButtons,
        RequestInfo
    },
    data() {
        return {
            creatingNew: false,
            selectedDocumentCount: 0,
            editorsVisible: false,
            formData: null,
            formButtons: { disabled: true, removeDisabled: true },
            action: '',
            targetList: [],
            dataToSubmit: null
        };
    },
    computed: {
        documentOptionId() {
            if (this.formData == null) {
                return ''
            }
            if (
                this.formData != 'undefined' &&
                this.formData.id != 'undefined'
            ) {
                return this.formData.id.toString()
            } else {
                return ''
            }
        }
    },
    methods: {
        onListSelection(item) {
            var selectedDocCount = 0
            if (this.creatingNew) {
                // creating a new document does not change existing options
                return
            }
            if (Array.isArray(item)) {
                selectedDocCount = item.length
                this.selectedDocumentCount = item.length
            } else {
                selectedDocCount = 0
                this.selectedDocumentCount = 0
            }
            if (selectedDocCount == 1) {
                var copy = Object.assign({}, item[0])
                this.formData = copy
                this.formButtons.disabled = false
                this.formButtons.removeDisabled = false
                this.editorsVisible = true
                this.action = 'item'
                try {
                    this.targetList = JSON.parse(copy.destination) || []
                } catch (error) {
                    console.log(error)
                    this.targetList = []
                }
            } else {
                this.formData = null
                this.targetList = []
                this.formButtons.disabled = true
                this.formButtons.removeDisabled = true
                this.editorsVisible = false
                this.action = ''
            }
        },
        createNewDoc() {
            this.creatingNew = true
            this.$refs.optionList.deselectAll()
            this.targetList = []
            this.formButtons.disabled = false
            this.formButtons.removeDisabled = true
            this.formData = null
            this.editorsVisible = true
            this.action = 'new'
        },
        submitDocumentData() {
            const txt = this.$refs.txtFormEditor.collectFormData();
            const validities = this.$refs.validityEditor.collectValidityData();
            const targets = this.$refs.targetCtrl.getTargets();

            const submitData = txt;
            submitData.documentOptionJsonMsg.validityBegins = validities.validityBegins;
            submitData.documentOptionJsonMsg.validityEnds = validities.validityEnds;
            const destinations = [
                ...targets.routeTargets.map(route => ({ id: route.id, label: route.label, type: 'route' })),
                ...targets.vehicleTargets.map(vehicle => ({ id: vehicle.id, label: vehicle.label, type: 'vehicle' })),
            ];
            submitData.documentOptionJsonMsg.destinations = destinations;

            this.dataToSubmit = submitData;

            this.$store.dispatch('documents/submitDocumentData', submitData)
                .then(() => {
                    this.resetDocumentData();
                    this.refreshDocumentOptionList();
                })
                .catch(error => {
                    console.error('Submit failed:', error);
                });
        },
        resetDocumentData() {
            this.$refs.txtFormEditor.resetForm()
            this.formButtons.disabled = true
            this.formButtons.removeDisabled = true
            this.editorsVisible = false
            this.creatingNew = false
            this.$refs.optionList.deselectAll()
        },
        removeDocumentOption() {
            if (this.formData.id != undefined) {
                const id = this.formData.id;
                this.$travellerRemove();
                this.$store
                    .dispatch('documents/removeDocumentOption', id)
                    .then(() => {
                        this.$travellerRemoved();
                        this.resetDocumentData();
                        this.refreshDocumentOptionList();
                    })
                    .catch(error => {
                        console.error('Remove failed:', error);
                    });
            }
        },
        refreshDocumentOptionList() {
            this.$refs.optionList.fetchOptions();
        },
    },
    beforeCreate() {
        if (!this.$store.state.documents) {
            this.$store.registerModule('documents', documents)
        }
    },
}
</script>
